import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { ComingSoon } from "@/components/common";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/pricing/plans").then((r) => setPlans(r.data)); }, []);

  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="text-center max-w-2xl mx-auto">
          <h1 className="font-heading text-5xl font-black tracking-tight">Pricing</h1>
          <p className="mt-4 text-xd-muted">Plans built for every stage — from your first truck to a growing fleet.</p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {plans.map((p, i) => (
            <div key={p.id} data-testid={`plan-${p.name}`} className={`rounded-2xl border p-8 flex flex-col ${i === 1 ? "border-xd-orange bg-gradient-to-b from-xd-orange/10 to-xd-paper" : "border-xd-border bg-xd-paper"}`}>
              {i === 1 && <span className="self-start text-[10px] uppercase tracking-wide font-bold text-xd-orange bg-xd-orange/15 border border-xd-orange/30 rounded-full px-3 py-1 mb-3">Most Popular</span>}
              <h3 className="font-heading text-2xl font-black">{p.name}</h3>
              <p className="mt-1 text-sm text-xd-muted">{p.tagline}</p>
              <p className="mt-6 font-heading text-4xl font-black text-white">{p.price_label}<span className="text-base font-semibold text-xd-muted">{p.price_period}</span></p>
              <ul className="mt-6 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-xd-muted"><Check size={16} className="text-xd-green mt-0.5 shrink-0" /> {f}</li>
                ))}
              </ul>
              <Button asChild data-testid={`plan-cta-${p.name}`} className={`mt-8 h-11 font-bold ${i === 1 ? "bg-xd-orange hover:bg-xd-orangeH text-white" : "bg-xd-surface hover:bg-xd-border text-white"}`}>
                <Link to="/register">{p.cta}</Link>
              </Button>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
